import { onConnect } from '@sonicgarden/onconnect';

$('.js-tour-schedules').on('cocoon:after-insert', (e, $insertedItem) => {
  const $dateInputs = $insertedItem.closest('.js-tour-schedules').find('.nested-fields:visible input[type="date"]');
  const dateInput = $dateInputs[$dateInputs.length - 2];
  if (dateInput) {
    $insertedItem.find('input[type="date"').val(dateInput.value);
  }
});

onConnect('.js-add-tour-schedule-link', (link) => {
  $(link).data('association-insertion-node', (link) => link.closest('.nested-fields').find('.js-tour-schedules'));
});

// tour_schedule行の複製機能 ----------------------------------
const createNewId = function () {
  return new Date().getTime() + Math.floor(Math.random() * 1000);
};

const updateFormAttributes = function (element, newId) {
  // 対象となるattributes名のパターン
  const scheduleAttributePatterns = ['tour_schedules_attributes', 'actual_tour_schedules_attributes'];
  const formElements = element.querySelectorAll('input, select, textarea');

  formElements.forEach((input) => {
    let name = input.getAttribute('name');
    let id = input.getAttribute('id');

    // 各パターンに対してname属性を更新
    if (name) {
      scheduleAttributePatterns.forEach((pattern) => {
        if (name.includes(pattern)) {
          // name属性の最後の[数字]部分のみ更新
          // 例: tour_outline[tour_schedule_sections_attributes][123][tour_schedules_attributes][456][event_name]
          //     → tour_outline[tour_schedule_sections_attributes][123][tour_schedules_attributes][newId][event_name]
          const nameRegex = new RegExp(`(\\[${pattern}\\])\\[(\\d+)\\]`);
          name = name.replace(nameRegex, `$1[${newId}]`);
        }
      });
      input.setAttribute('name', name);
    }

    // 各パターンに対してid属性を更新
    if (id) {
      scheduleAttributePatterns.forEach((pattern) => {
        if (id.includes(pattern)) {
          // id属性の最後の_数字_部分のみ更新
          // 例: tour_outline_tour_schedule_sections_attributes_123_tour_schedules_attributes_456_event_name
          //     → tour_outline_tour_schedule_sections_attributes_123_tour_schedules_attributes_newId_event_name
          const idRegex = new RegExp(`(${pattern}_)(\\d+)(_)`);
          id = id.replace(idRegex, `$1${newId}$3`);
        }
      });
      input.setAttribute('id', id);
    }
  });
};

document.addEventListener('click', (e) => {
  if (e.target.closest('.js-duplicate-schedule')) {
    e.preventDefault();
    const button = e.target.closest('.js-duplicate-schedule');
    const row = button.closest('.nested-fields');

    const clonedRow = row.cloneNode(true);
    const newId = createNewId();

    updateFormAttributes(clonedRow, newId);

    // hiddenのidフィールドをクリア
    const hiddenIdInputs = clonedRow.querySelectorAll('input[type=hidden][name$="[id]"]');
    hiddenIdInputs.forEach((input) => input.value = '');

    row.insertAdjacentElement('afterend', clonedRow);
  }
});
// -------------------------------------------------------------
